import Sync from '@material-ui/icons/Sync';
import * as React from 'react';
import styled from 'styled-components';

interface IAnimatedSyncIconProps {
    className?:any;
}

type Props = IAnimatedSyncIconProps;

class AnimatedSyncIcon extends React.Component<Props> {
    public render() {
        return (<Sync className={ this.props.className }/>);
    }
};

export default styled(AnimatedSyncIcon)`
            
    -webkit-animation:spin 4s linear infinite;
    -moz-animation:spin 4s linear infinite;
    animation:spin 4s linear infinite;
    @-moz-keyframes spin { 100% { -moz-transform: rotate(-360deg); } }
    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(-360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(-360deg); transform:rotate(-360deg); } }
`;


// WEBPACK FOOTER //
// ./src/icons/AnimatedSyncIcon.tsx